import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'employeeActivity';

const employeeActivityService = {
  getItems: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/activities`,
    });
  },
};
export default employeeActivityService;
